import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';

import { PrizeService } from '../prize.service';

@Component({
    selector: 'app-prize-edit',
    templateUrl: './prize-edit.component.html',
    styleUrls: ['./prize-edit.component.scss'],
    standalone: false
})
export class PrizeEditComponent extends BaseComponent implements OnInit, AfterViewInit {

  public canEditPrize: boolean = false;
  public id: string;

  public form = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    }),
    description: new FormControl('',{
      validators: Validators.required
    }),
    value: new FormControl('',{
      validators: Validators.required
    }),
    expenseCost: new FormControl(),
    outingIterationId: new FormControl('',{
      validators: Validators.required
    })
  });


  constructor(public sessionService: SessionService,
    private prizeService: PrizeService,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers,
    private router: Router,
    private route: ActivatedRoute) {
    super(sessionService, stringHelpers);}

  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.canEditPrize =  this.checkIterationDate();
      this.id = this.route.snapshot.paramMap.get('id');
      this.getPrize();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.subscribe(result => {
      this.selectedIteration = result;
      this.canEditPrize = this.checkIterationDate();
    });
  }

  getPrize(){
    this.prizeService.getById(this.id).subscribe(result => {
      this.form.patchValue(result);
    });
  }

  onSubmit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      value.lastEditedBy = this.sessionService.getUserId();
      value.outingIterationId = this.selectedIteration.id;
      value.id = this.id;
      this.prizeService.update(this.id, value).subscribe(() => {
        this.isLoading = false;
        this.form.reset();
        this.form.clearAsyncValidators();
        this.form.clearValidators();
        this.isLoading = false;
        this.router.navigate([`/outing-management/administration/prizes`]);
      }, (err: any) => {
        this.isLoading = false;
        if (err.status === 400) {
          this.setError(err, this.form);
        }
      });
    }
  }

}
